module.exports = __webpack_public_path__ + "img/vertical_4_5_7042.c1bf7adb.png";